/*
 * Module for the Topic title
 */

define([
  "marionette",
  "configuration/properties",
  "messaging/messenger",
  "./topicTitleView",
], function (Marionette, Properties, Messenger, TopicTitleView) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "topicTitle";
    },
    show: function (topic) {
      this.topic = topic;
      if (topic.isNew()) {
        topic.allowEditTopicName = true;
      } else {
        topic.allowEditTopicName = Messenger.reqres.request("can:edit:topicName");
      }
      topic.readOnly = Messenger.reqres.request("topic:read:only");
      this.view = new TopicTitleView.topicTitleView({ model: topic });
      //when a new topic's view is loaded, open a textbox to edit
      if (topic.isNew()) {
        this.view.on(
          "show",
          function () {
            this.view.enableTextbox("#topicTitleText");
          },
          this,
        );
      }
      this.listenTo(topic, "enter:intentName", function () {
        document.title = topic.get("intentName") + " - " + Properties.applicationName;
      });
      this.showRegion(this.view);
    },
    nameError: function (errorMessage) {
      this.view.nameError(errorMessage);
    },
  });
});
